import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FieldOption } from '../common/field-option.enum';
import { SharedFormService } from '../services/shared-form.service';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropDownComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() public labelName: string;
  @Input() public controlName: string;
  @Input() public formGroup: FormGroup;
  @Input() public whichDropDown: FieldOption;
  @Input() public errorMessage: string;
  // @Input() public dataDefault: string

  @ViewChild('stateRef', {static: false}) stateRef: ElementRef;

  blnShowData: boolean = false;
  blnShowError: boolean = false;
  eventSub: Subscription;

  
  dataBind: any[];
  displayLs: any[];
  constructor(private formSvc: SharedFormService) { }

  ngOnInit() {
     this.eventSub = this.formSvc.formStatusEvent.subscribe((errorKey:string)=> {
        if(this.controlName === errorKey){
          this.blnShowError = true;
        }
      })
     this.setDataOptions();
    
  }
  ngAfterViewInit(): void {
    // console.log('Current Drop Down Value => ', this.formGroup.get(this.controlName).value);
    /*const foundItem  = this.dataBind.find(item => item.value === this.formGroup.get(this.controlName).value);
    if( foundItem) {
      this.stateRef.nativeElement.innerHTML = foundItem.label;
    }*/
  }
  private setDataOptions(): void {
    if (this.whichDropDown === FieldOption.DropdownState) {
      this.dataBind = this.formSvc.getStatesData();
    } else if (this.whichDropDown === FieldOption.DropDownOfficeContact) {
      this.dataBind = this.formSvc.getOfficeContact();
    } else if( this.whichDropDown === FieldOption.DropDownOfficeProfessional) {
      this.dataBind = this.formSvc.getOfficeProfessional();
    }
    this.displayLs = [...this.dataBind];
    this.setDefaultOption(this.displayLs[0]);
  }
  showData(): void{
    this.blnShowData = !this.blnShowData;
    this.displayLs = [...this.dataBind];
  }
  stateSelected(item: any): void {
     // console.log('state selected...');
    this.stateRef.nativeElement.innerHTML = item.label;
    // this.stateRef.nativeElement.value = item.label;
    this.blnShowData = false;
    this.formGroup.get(this.controlName).setValue(item.value);
    if(this.controlName.startsWith('officeContactId')){
      const justId = this.controlName.replace(/\D/g,'');
      const newControlName = 'officeContactType' + justId;
      this.formGroup.get(newControlName).setValue(item.label);
    }
    /*if(this.controlName.startsWith('officeProfessional')){
      this.formGroup.get(this.controlName).setValue(item.label);
    }*/
   }
   onSelect(event): void {

    if(event && event.target.value) {
   
      this.formGroup.get(this.controlName).setValue(event.target.value);
      this.onChangeValue(event);
      this.blnShowError = false;
    } else {
      this.blnShowError = true;
    }
   }
   setDefaultOption(item: any) {
    if(this.controlName.startsWith('officeContactId')){
      const justId = this.controlName.replace(/\D/g,'');
      const newControlName = 'officeContactType' + justId;
      this.formGroup.get(newControlName).setValue(item.label);
    }
    if(this.controlName.startsWith('officeProfessional')){
      const justId = this.controlName.replace(/\D/g,'');
        const newControlName = 'officeProfessionalType' + justId;
        this.formGroup.get(newControlName).setValue(item.label);
    }
   }
   onChangeValue(event): void {
    
     
      if(this.controlName.startsWith('officeContactId')){
        const justId = this.controlName.replace(/\D/g,'');
        const newControlName = 'officeContactType' + justId;
        let text = event.target.options[event.target.options.selectedIndex].text;
        this.formGroup.get(newControlName).setValue(text);
      }
      if(this.controlName.startsWith('officeProfessional')){
        const justId = this.controlName.replace(/\D/g,'');
        let text = event.target.options[event.target.options.selectedIndex].text;
        const newControlName = 'officeProfessionalType' + justId;
        this.formGroup.get(newControlName).setValue(text);
      }
     
   }
   onBlurOut(): void {
     // console.log('Firing blur event');
     // this.blnShowError=!this.formGroup.get(this.controlName).valid;
     this.blnShowData = false;

   }
   onFilterValues(event): void {
   // console.log('Checking Drop Down Key => ', event.key);
    const re = /^[a-zA-Z]{1}$/g;
    if(!re.test(event.key)) {
      return;
    }
    const result = this.dataBind.filter(item => item.label.toLowerCase().startsWith(event.key));
    if(result && result.length === 1) {
      this.blnShowData = false;
      this.stateRef.nativeElement.innerHTML = result[0].label;
      this.formGroup.get(this.controlName).setValue(result[0].value);
    } else if (result && result.length > 1) {
      this.displayLs = [...result];
    }
   }
   showDropDown(): void{
     this.blnShowData = true;
   }
   ngOnDestroy(): void {
    if(this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }

}
